module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-wrap",
    attrs: {
      "id": "notifications"
    }
  }, [_c('div', {
    staticClass: "notifications-danger"
  }, [(_vm.notifications.danger) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.danger) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeDanger.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notifications-warning"
  }, [(_vm.notifications.warning) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.warning) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeWarning.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notifications-success"
  }, [(_vm.notifications.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissible"
  }, [_vm._v("\n      " + _vm._s(_vm.notifications.success) + "\n      "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeSuccess.apply(null, arguments)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b2e7d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications.vue
// module id = 903
// module chunks = 0